import * as React from "react";

export function VerifyEmailLandingPage(): JSX.Element {
  return (
    <div className="p-6">
      <h1 className="text-xl font-medium mb-2">Email Verified</h1>
      <p className="text-sm text-muted-foreground">Thanks! Your email has been verified.</p>
    </div>
  );
}

